import React, { useMemo } from 'react'
import * as THREE from 'three'

export default function Stars({ count = 10000 }) {
  const positions = useMemo(() => {
    const pos = new Float32Array(count * 3)

    for (let i = 0; i < count; i++) {
      // Spherical coordinates - hamma tomondan o'rab turadi
      const radius = 50 + Math.random() * 100 // 50 dan 150 gacha (uzoqda)
      const theta = Math.random() * Math.PI * 2 // 0 dan 360 gacha
      const phi = Math.acos(2 * Math.random() - 1) // tepadan pastgacha

      pos[i * 3 + 0] = radius * Math.sin(phi) * Math.cos(theta) // X
      pos[i * 3 + 1] = radius * Math.sin(phi) * Math.sin(theta) // Y
      pos[i * 3 + 2] = radius * Math.cos(phi) // Z
    }

    return pos
  }, [count])

  return (
    <points>
      <bufferGeometry>
        <bufferAttribute
          attach='attributes-position'
          array={positions}
          count={count}
          itemSize={3}
        />
      </bufferGeometry>
      <pointsMaterial
        size={0.03}
        color='white'
        sizeAttenuation={true}
        transparent={false}
      />
    </points>
  )
}
